export class FetchRetailers {
	static readonly type = '[Select Party] Fetch All Retailers';
	constructor(
    public payload: any
	) { }
}
export class FetchRetailersAgain {
	static readonly type = '[Select Party] Fetch All Retailers Again';
	constructor(
    public payload: any
	) { }
}

export class FetchDistributors {
	static readonly type = '[Select Party] Fetch All Distributors';
	constructor(
    public payload: any
	) { }
}

export class ResetSelectParty {
	static readonly type = '[Select Party] Reset Select Party State';
	constructor(public key: string = null) { }
}